import { BaseApi } from './base';

class TeacherApi extends BaseApi {
  constructor() {
    super('teacher');
  }

  startWebinar(id) {
    return this.post(`/webinar/${id}`, { id });
  }

  endWebinar(id) {
    return this.post(`/webinar/end/${id}`, { id });
  }

  getWebinars() {
    return this.get('/webinars');
  }

  getGroups() {
    return this.get('/groups');
  }

  scheduleWebinar(data) {
    return this.post('/webinar', data);
  }

  changeWebinar(data) {
    return this.update('/webinar', data)
  }

  getLessons(data) {
    return this.post('/program', data);
  }

  getHomeworks() {
    return this.get('/homeworks');
  }

  evaluateHomeWork(data) {
    return this.post('/homework', data);
  }
}

export default new TeacherApi();
